import type { ComponentChildren } from 'preact'

// Shared section chrome for the blast detail surfaces. Lives apart from the sections themselves because
// BlastEngagementSection and BlastRecipientsSection import it too, and a section file that owns a symbol
// its siblings depend on cannot be reorganised without breaking them (ORB-706).

export function SectionHeading({ icon, children }: { icon?: ComponentChildren; children: ComponentChildren }) {
  return (
    <h3 className="flex items-center gap-2 text-sm font-semibold text-slate-700 dark:text-slate-200">
      {icon && <span className="text-slate-400 dark:text-slate-500">{icon}</span>}
      {children}
    </h3>
  )
}

export function Stat({
  label,
  value,
  tone,
  hint,
}: {
  label: string
  value: number
  tone?: 'warn' | 'danger'
  hint?: string
}) {
  const valueColor =
    tone === 'danger'
      ? 'text-red-600 dark:text-red-400'
      : tone === 'warn'
      ? 'text-amber-600 dark:text-amber-400'
      : 'text-slate-900 dark:text-white'
  return (
    <div>
      <dt
        title={hint}
        className={
          'text-[10px] uppercase tracking-wide text-slate-400 dark:text-slate-500' +
          (hint ? ' cursor-help underline decoration-dotted underline-offset-2' : '')
        }
      >
        {label}
      </dt>
      <dd className={`mt-1 text-lg font-semibold tabular-nums ${valueColor}`}>{value.toLocaleString()}</dd>
    </div>
  )
}
